import { generateMetaTags } from 'helpers';
import LegalPages from 'Layout/LegalPages';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchRefundPolicy,
    selectRefundPolicy,
    selectRefundPolicyIsLoading,
    selectRefundPolicyTags,
} from 'store/slices/LegalSlice';

const RefundPolicy = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectRefundPolicyIsLoading);
    const data = useSelector(selectRefundPolicy);

    const refundPolicyTags = useSelector(selectRefundPolicyTags);
    const metaTags = generateMetaTags(refundPolicyTags?.tags, 'meta');

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchRefundPolicy());
    }, [dispatch]);

    const { blocks, title, updatedAt } = data;

    return <LegalPages loading={isLoading} title={title} blocks={blocks} updatedAt={updatedAt} metaTags={metaTags} />;
};

export default RefundPolicy;
